import { render, staticRenderFns } from "./GoToChat.vue?vue&type=template&id=2584093d&scoped=true&"
import script from "./GoToChat.vue?vue&type=script&lang=js&"
export * from "./GoToChat.vue?vue&type=script&lang=js&"
import style0 from "./GoToChat.vue?vue&type=style&index=0&id=2584093d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2584093d",
  null
  
)

export default component.exports